<template>
  <div>
    <div v-if="groupLayoutId" class="d-flex flex-wrap">
      <div v-for="(item,index) in message.getPhotoList" :key="index" class="">
        <el-image class="pointer m-1" style="max-height: 240px;max-width: 220px;border: 2px solid #dcdfe9 "
                  :src="getCloudUrl(item.url,item.globalMes)"
                  :preview-src-list="getImageAndVideo()">
          <div slot="error">
            <ImageRefresh class="pointer "
                          :url="item.url" :preview-src-list="getImageAndVideo()" />
          </div>
        </el-image>
      </div>
    </div>

    <div v-else>
      <div v-if="messageRepied" class="rounded d-flex align-items-center">
        <img class=" rounded align-self-center" :src="getUrlHDIfExist" :preview-src-list="getImageAndVideo()"
             style="width: 33px;height:33px;object-fit: cover;" />

        <div class="ms-2">[Hình ảnh]</div>
      </div>
      <div v-else>
        <div>
          <el-image class="pointer"
                    :src="getUrlHDIfExist" fit="contain"
                    :preview-src-list="getImageAndVideo()"
                    v-bind:style="quote?'max-width: 60px;max-height: 60px':'max-height: 450px'">
            <div slot="error">
              <ImageRefresh class="pointer "
                            :url="getUrlHDIfExist" :preview-src-list="getImageAndVideo()" />
            </div>
          </el-image>
        </div>
        <div class="mb-0 mt-1 text-normal" style="white-space: pre-line">{{ title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON } from "../../lib/Common";
import ImageRefresh from "../common/ImageRefresh";

export default {
  name: "ChatPhoto",
  components: { ImageRefresh },
  props: ["href", "title", "quote", "messageList", "message", "groupLayoutId", "messageRepied"],
  data() {
    return {
      load: false
    };
  },


  computed: {
    getUrlHDIfExist() {

      try {
        let linkHD = JSON.parse(JSON.parse(this.message.content).params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return this.getCloudUrl(linkHD, this.message);
        }
      } catch (e) {
        // Ignore
      }
      return this.getCloudUrl(this.href, this.message);
    }
  },
  methods: {

    findUrlHDIfExist(content) {
      try {
        let linkHD = JSON.parse(JSON.parse(content).params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return linkHD;
        }
      } catch (ex) {
        // Ignore
      }
      return JSON.parse(content).href;
    },
    // getPhotoList() {
    //   let photos = [];
    //   let filter = this.messageList.filter(p => p.msgType == "chat.photo");
    //   filter.forEach(item => {
    //     this.getPhoto(photos, item);
    //   });
    //   return photos.sort((a, b) => b.id - a.id);
    // },
    // getPhoto(photos, item) {
    //   console.log(1);
    //   let params = JSON.parse(JSON.parse(item.content).params);
    //   if (params.is_group_layout) {
    //     if (params.group_layout_id == this.groupLayoutId) {
    //       photos.push({ id: params.id_in_group, url: this.getCloudUrl(this.findUrlHDIfExist(item.content), item) });
    //     }
    //   }
    // },
    getImageAndVideo() {
      if (this.messageList) {
        let data = this.messageList.filter(s => s.msgType == COMMON.CHAT_PHOTO).map(s => this.getCloudUrl(this.findUrlHDIfExist(s.content), s));
        return data;
      } else {
        return [];
      }
    }
  },

  created() {
  }
};
</script>

<style scoped></style>
